import { get } from "../../service/api";

const GetSettleTransaction = async (merchantId, merchantSettleId, page = 1, size = 20) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/transaction?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        console.error('Error GetSettleTransaction:', error);
        throw error;
    }
};

export default GetSettleTransaction;
